import { Link } from 'react-router-dom'

export default function TrialWarningBanner({ daysRemaining, orgName }) {
  if (daysRemaining > 3) return null

  const isUrgent = daysRemaining <= 1
  const bgColor = isUrgent ? 'bg-red-600' : 'bg-amber-500'

  return (
    <div className={`${bgColor} text-white py-2 px-4`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm font-medium">
            {daysRemaining <= 0
              ? `Your free trial for ${orgName} has expired!`
              : daysRemaining === 1
                ? `Your free trial ends tomorrow!`
                : `Your free trial ends in ${daysRemaining} days`}
          </span>
        </div>
        <Link
          to="/billing"
          className={`text-sm font-semibold ${isUrgent ? 'bg-white text-red-600' : 'bg-white text-amber-600'} px-4 py-1 rounded-full hover:opacity-90 transition-opacity`}
        >
          Subscribe Now
        </Link>
      </div>
    </div>
  )
}
